import { ChevronLeftIcon, ChevronRightIcon } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type Props = {
  currentPage: number;
  totalPage: number;
  onClickFirstPage: () => void;
  onClickBackPage: () => void;
  onClickNextPage: () => void;
  onClickLastPage: () => void;
};

/**
 * ページネーションコンポーネント
 *
 * @param currentPage 現在のページ
 * @param totalPages 総ページ数
 * @param onClickFirstPage 最初のページに移動
 * @param onClickBackPage 前のページに移動
 * @param onClickNextPage 次のページに移動
 * @param onClickLastPage 最後のページに移動
 */
export const Pagination: React.FC<Props> = ({
  currentPage,
  totalPage,
  onClickFirstPage,
  onClickBackPage,
  onClickNextPage,
  onClickLastPage,
}) => (
  <div className={styles.Pagination}>
    <button onClick={onClickFirstPage} disabled={currentPage <= 1} aria-label='first page'>
      First
    </button>
    <button onClick={onClickBackPage} disabled={currentPage <= 1} aria-label='previous page'>
      <ChevronLeftIcon />
    </button>
    <div className={styles.Pagination__PageInfo}>
      Page {currentPage > totalPage ? totalPage : currentPage} of {totalPage}
    </div>
    <button onClick={onClickNextPage} disabled={currentPage >= totalPage} aria-label='next page'>
      <ChevronRightIcon />
    </button>
    <button onClick={onClickLastPage} disabled={currentPage >= totalPage} aria-label='last page'>
      Last
    </button>
  </div>
);
